import { cn } from '@/utils';

type DividerProps = {
  orientation?: 'horizontal' | 'vertical';
  decorative?: boolean;
  className?: string;
};

export function Divider({ orientation = 'horizontal', decorative = true, className }: DividerProps) {
  const isVertical = orientation === 'vertical';

  return (
    <div
      role={decorative ? 'none' : 'separator'}
      aria-orientation={decorative ? undefined : orientation}
      className={cn('shrink-0 bg-border', isVertical ? 'w-px self-stretch' : 'h-px w-full', className)}
    />
  );
}
